import { createContext } from "react";

type EnabledContext = {
  slideoutEnabled: boolean;
}
const SlideoutEnabledContext = createContext<EnabledContext>({ slideoutEnabled: false });

export default SlideoutEnabledContext;
